import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateUser } from '../../features/auth/authSlice' 
import SpinnerSmall from '../SpinnerSmall'; 
import { TopHeaderSettings, CenterSettingsContainer } from './settings.styled';
import ChurchUsernameChange from './profileSettings/ChurchUsernameChange';
import styled from 'styled-components';
import { SettingsInputContainer, SettingsSubmitButton, SettingsBody } from './settings.styled';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { toast } from 'react-toastify';
import { updateUsername } from 'features/settings/settingSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


function UpdateUserName(props) {
  const { t } = useTranslation('settings')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { isUpdateUsernameLoading, isUpdateUsernameSuccess, newUsername} = useSelector((state) => state.settings)
  const [ viewExample, setViewExample ] = useState(false)
  const [ viewHelp, setViewHelp ] = useState(false) 
  const [inputValue, setInputValue] = useState('')

  const handleChange = (e) => {
    // remove any spaces
    if(e.target.value.includes(' ')){
      return setInputValue(e.target.value.replace(/\s/g, ''))
    }else{
      return setInputValue(e.target.value)
    }
  }

  useEffect(() => {
    if(!user.isOrganization){
      navigate(`/settings`)
    }
  }, [user])

  const  handleSubmit = async () => {
    if(!inputValue){ return toast.error(t('accountEdit.usernameRequired')) }
    if(inputValue.length < 3){ return toast.error(t('accountEdit.usernameMinimum')) }
    if(inputValue.length >= 19){ return toast.error(t('accountEdit.usernameMaximum')) }

      dispatch(updateUsername({
        username: inputValue
      }))
      setInputValue('')
  
  }

  useEffect(() => {
    if(isUpdateUsernameSuccess && newUsername){
      dispatch(updateUser({
        type: 'name',
        value: newUsername
      }))
    }
  }, [isUpdateUsernameSuccess, newUsername])


  return (

    <CenterSettingsContainer>
        <TopHeaderSettings>{t('accountEdit.updateUsername')}</TopHeaderSettings>

        <SettingsBody>


          <SettingsInputContainer 
            > 
            <input
                maxLength={20}
                value={inputValue}
                onChange={handleChange}
                placeholder={t('accountEdit.churchUsernamePlaceholder')}
                />
            <SettingsSubmitButton

              disabled={isUpdateUsernameLoading}
              onClick={handleSubmit}
              >
                {isUpdateUsernameLoading ? <SpinnerSmall /> : t('accountEdit.update')}
            </SettingsSubmitButton>
          </SettingsInputContainer>          


          <ViewExample>
            <HelpOutlineIcon 
              onClick={() => setViewHelp(!viewHelp)}
              />

            { viewHelp && 
              (
                <>
                  <h5>{t('accountEdit.usernameWhy')}</h5>
                  <p>{t('accountEdit.usernameExplanation', { username: user.name })}</p>
                </>
              )
            }

            <span onClick={() => setViewExample(!viewExample)}>{t('accountEdit.viewExample')}</span>
          </ViewExample>

          {
            viewExample && (
              <ChurchUsernameChange />
            )
          }
        
        </SettingsBody>

    </CenterSettingsContainer>

  )
}

export default UpdateUserName

const ViewExample = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 20px;
  color: var(--lightThemeFontColor);

  p{
    text-align: left;
    line-height: normal;
    font-size: 11px;
    font-weight: 400;
    margin-bottom: 10px;
  }

  svg{
    cursor: pointer;
    margin-bottom: 11px;
    font-size: 20px;  
    &:hover{
    
      color: var(--themeColor);
    
    }
  }

  span{
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
    color: var(--themeColor);
    &:hover{
      text-decoration: underline;
    }

    margin-bottom: 20px;
  }


`
